import {ChangeDetectionStrategy, Component, computed, input, signal} from '@angular/core';
import {DataLayerParamsClickGA4} from '../../../types/DataLayerParamsClickGA4';

@Component({
  selector: 'app-telephone',
  templateUrl: './telephone.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TelephoneComponent {
  public telephoneNumber = input<string>();
  public telephoneLabel = input<string>();
  public label = input<string>();
  public customGa4Params = input<DataLayerParamsClickGA4>(null);

  public isTelephoneVisible = signal<boolean>(false);
  public maskedTelephone = computed<string>(() => this.maskText(this.telephoneNumber()));
  public eventParams = computed<DataLayerParamsClickGA4>(() => ({
    ...this.customGa4Params(),
    callToAction: `telefonnummer - visa telefonnummer - ${this.label()}`,
  }));

  public showTelephone(): void {
    this.isTelephoneVisible.set(true);
  }

  private maskText(text: string): string {
    return text.replace(/[^ ](?!.{4})/gm, '#');
  }
}
